/* eslint-disable max-len */

const premiumMassageImages = {
  fiveStarReflexology: require('./five-star-reflexology.webp'),
  fullSpaBodyMassageAndCreambath: require('./full-spa-body-massage-and-creambath.webp'),
  fullSpaBodyMassageAndKerokan: require('./full-spa-body-massage-and-kerokan.webp'),
  fullSpaBodyMassageAndLuluran: require('./full-spa-body-massage-and-luluran.webp'),
  fullSpaBodyMassage: require('./full-spa-body-massage.webp'),
  hotStoneSpaMassage: require('./hot-stone-spa-massage.webp'),
  pregnancyMassage: require('./pregnancy-massage.webp'),
  serenitySpaReflexolgyAndBodyMassage: require('./serenity-spa-reflexolgy-and-body-massage.webp'),
  chevronRight: require('./chevron-right.webp'),
  infoIcon: require('./info-icon.webp'),
  timeIcon: require('./time-icon.webp'),
  checkIcon: require('./check-icon.webp'),
  dryCupping: require('./dry-cupping.webp'),
  momBabyMassage: require('./mom-baby-massage.webp'),
  sprainMassage: require('./sprain-massage.webp'),
  totokWajah: require('./totok-wajah.webp'),
  crossIcon: require('./cross-icon.svg')
}

export default premiumMassageImages
